import React from 'react';

import _ from 'lodash';

import InputTextField from './InputTextField';
import InputCurrencyField from './InputCurrencyField';

import './InvoicePaymentLineItemEntryTableRow.scss';

class InvoicePaymentLineItemEntryTableRow extends React.Component {
  state = {
    selected: false
  };

  onSelectedChange = value => {
    this.setState({ selected: value });
  }

  _onInputChange(inputId) {
    return value => {
      const { onEntryChange } = this.props;

      const entry = _.cloneDeep(this.props.entry);
      entry.fields[inputId].value = value;

      onEntryChange(entry);
    };
  }

  render() {
    const {
      lineItem,
      entry,
      fieldConfiguration,
      inputId,
      editMode
    } = this.props;

    const {
      selected
    } = this.state;

    const lineItemTitleOptions = fieldConfiguration.line_item_title.options;

    const feeType = lineItem.fields.fee.value?.fields.type.value;
    const validation = lineItem.fields.validation.value;
    
    // Title for normal line items
    const feeTitle = feeType ? `${feeType} Fee` : null;

    // Title for carryover invoice line items
    const rateTypeTitleRaw = lineItem.fields.line_item_rate_type.value;
    const rateTypeTitleOption = lineItemTitleOptions.find(option => option.value === rateTypeTitleRaw);
    const rateTypeTitle = rateTypeTitleOption?.label;

    // Title for validation invoice line items
    const validationTitleRaw = validation?.fields.type.value;
    const validationTitleOption = lineItemTitleOptions.find(option => option.value === validationTitleRaw);
    const validationTitle = validationTitleOption?.label;

    const lineItemTitle = feeTitle || rateTypeTitle || validationTitle || 'Charge';

    return (
      <div className="parkchirp--invoice-payment-line-item-entry-table-row">
        <div className="parkchirp--selected-column parkchirp--invoice-payment-line-item-entry-table--cell">
          <input type="checkbox"
            checked={selected}
            onChange={event => this.onSelectedChange(event.target.checked)}
          />
        </div>
        <div className="parkchirp--invoice-line-item-title-column parkchirp--invoice-payment-line-item-entry-table--cell">
          <InputTextField inputId={`${inputId}--line-item--title`}
            value={lineItemTitle}
            editMode={false}
          />
        </div>
        <div className="parkchirp--invoice-line-item-parker-name-column parkchirp--invoice-payment-line-item-entry-table--cell">
          <InputTextField inputId={`${inputId}--line-item--parker-name`}
            value={[
              lineItem.fields.parker.value?.fields.first_name.value || '',
              lineItem.fields.parker.value?.fields.last_name.value || ''
            ].join(' ')}
            editMode={false}
          />
        </div>
        <div className="parkchirp--invoice-line-item-balance-column parkchirp--invoice-payment-line-item-entry-table--cell">
          <InputCurrencyField inputId={`${inputId}--line-item--balance`}
            value={lineItem.fields.balance.value}
            editMode={false}
          />
        </div>
        {(this.state.selected === true) &&
          <React.Fragment>
            <div className="parkchirp--payment-entry-amount-column parkchirp--invoice-payment-line-item-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount`}
                key={Math.random()}
                value={entry.fields.amount.value}
                onChange={this._onInputChange('amount')}
                editMode={editMode}
              />
            </div>
            <div className="parkchirp--payment-entry-amount-tax-1-column parkchirp--invoice-payment-line-item-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-1`}
                key={`amount-tax-1--${entry.fields.amount_tax_1.value || 0}`}
                value={entry.fields.amount_tax_1.value}
                onChange={this._onInputChange('amount_tax_1')}
                editMode={editMode}
              />
            </div>
            <div className="parkchirp--payment-entry-amount-tax-2-column parkchirp--invoice-payment-line-item-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-2`}
                key={`amount-tax-2--${entry.fields.amount_tax_2.value || 0}`}
                value={entry.fields.amount_tax_2.value}
                onChange={this._onInputChange('amount_tax_2')}
                editMode={editMode}
              />
            </div>
            <div className="parkchirp--payment-entry-amount-tax-3-column parkchirp--invoice-payment-line-item-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-3`}
                key={`amount-tax-3--${entry.fields.amount_tax_3.value || 0}`}
                value={entry.fields.amount_tax_3.value}
                onChange={this._onInputChange('amount_tax_3')}
                editMode={editMode}
              />
            </div>
            <div className="parkchirp--payment-entry-amount-tax-4-column parkchirp--invoice-payment-line-item-entry-table--cell">
              <InputCurrencyField inputId={`${inputId}--amount-tax-4`}
                key={`amount-tax-4--${entry.fields.amount_tax_4.value || 0}`}
                value={entry.fields.amount_tax_4.value}
                onChange={this._onInputChange('amount_tax_4')}
                editMode={editMode}
              />
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}

export default InvoicePaymentLineItemEntryTableRow;
